export default {
  '.MuiDataGrid-footerContainer': {
    minHeight: 'unset',
  },
  '.MuiTablePagination-root': {
    marginY: '4px',
  },
  '.MuiTablePagination-toolbar': {
    color: (theme) => theme.palette.grays.gray500,
    minHeight: 'unset',
    '.MuiTablePagination-selectLabel': {
      fontSize: '0.75rem',
      margin: 0,
    },
    '.MuiTablePagination-select': {
      fontSize: '0.75rem !important',
      width: 'max-content',
      minWidth: 'unset !important',
      '.MuiSelect-icon': {
        fontSize: '1rem',
      },
    },
    '.MuiTablePagination-displayedRows': {
      fontSize: '0.75rem',
      margin: 0,
    },
    '.MuiTablePaginationActions-root': {
      '.MuiIconButton-root': {
        padding: '4px',
        '.MuiSvgIcon-root': {
          fontSize: '1.5rem',
        },
      },
    },
  },
};
